// extracted by mini-css-extract-plugin
export default {"hero":"OfV01_tQjFsVbmY0D_Wy","image":"Dbocv47pNoYHSkaaElvj","container":"EA1VyIMYCD4tu0L8T1HO"};